"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _constants = require("@ahmdigital/constants");
var _index = require("../utils/index");
var _default = {
    id: '50',
    isEligible: function() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productId = _ref.productId, scale = _ref.scale;
        if (!productId || !scale) return false;
        return scale === _constants.SCALE.SINGLE && (0, _index.isLowerValuePackageOrCombined)(productId);
    },
    isUpsellApplicable: function() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productId = _ref.productId, scale = _ref.scale;
        if (!productId || !scale) return false;
        return scale === _constants.SCALE.SINGLE && (0, _index.isLowerValueHospitalOrExtras)(productId);
    }
};
